const socketClusterClient = require('socketcluster-client');

const options = {
	port: 8001,
	hostname: process.env.VUE_APP_WS_SERVER,
	autoConnect: true,
	secure: false,
	rejectUnauthorized: false,
	connectTimeout: 10000, //milliseconds
	ackTimeout: 10000, //milliseconds
	channelPrefix: null,
	disconnectOnUnload: true,
	autoReconnectOptions: {
		initialDelay: 10000, //milliseconds
		randomness: 10000, //milliseconds
		multiplier: 1.5, //decimal
		maxDelay: 60000, //milliseconds
	},
	authEngine: null,
	codecEngine: null,
};

const socketClusterService = {
	agClientSocket: null,
	socket: null,

	create: async function () {
		this.agClientSocket = socketClusterClient.create(options);
		console.log("this.agClientSocket", this.agClientSocket);
	},

	listenChannel: async function (channelName, callback) {
		console.log({ socketListenChanel: channelName });
		let channel = this.agClientSocket.subscribe(channelName);
		for await (let data of channel) {
			callback(data);
		}
	},

	killChannel: async function (channelName) {
		console.log({ socketEvent: 'killChannel', channelName: channelName });
		this.agClientSocket.killChannel(channelName);
	},

	listen: async function (event, callback) {
		for await (let socket of this.agClientSocket.listener(event)) {
			callback(socket);
		}
	},
};

export default socketClusterService;
